module.exports = __webpack_public_path__ + "img/05.6e30d7c6.jpg";